import { inject, computed } from 'vue';

/**
 * Using method meant to inject a reactive component
 * 
 * @param key The current key we want to reactivly inject
 * @param defaultValue The current default value for the reactive property
 * @returns Will return the item that is reactive
 */
export const useReactiveInject = <T>(key: string, defaultValue?: T) => {
  const reactiveInjection = inject<Record<string, T>>('__reactiveInject__', {});
  const item = computed(() => reactiveInjection[key] ?? defaultValue);
  return item;
};